"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAccountListItemToSearchAccountItemType = exports.getAccountListItemUserType = exports.getAccountListItemDisplayName = void 0;
const getAccountListItemDisplayName = (item) => {
    var _a, _b, _c, _d;
    return ((_d = (_b = (_a = item === null || item === void 0 ? void 0 : item.virtualAccount) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = item === null || item === void 0 ? void 0 : item.user) === null || _c === void 0 ? void 0 : _c.displayName) !== null && _d !== void 0 ? _d : 'unknown');
};
exports.getAccountListItemDisplayName = getAccountListItemDisplayName;
const getAccountListItemUserType = (item) => {
    var _a, _b;
    return ((_b = (_a = item === null || item === void 0 ? void 0 : item.user) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : ((item === null || item === void 0 ? void 0 : item.virtualAccount) ? 'virtual' : undefined));
};
exports.getAccountListItemUserType = getAccountListItemUserType;
const mapAccountListItemToSearchAccountItemType = (item) => {
    var _a;
    return ({
        id: item.id,
        name: (0, exports.getAccountListItemDisplayName)(item),
        accountType: item.type,
        userType: (0, exports.getAccountListItemUserType)(item),
        balance: item.balance,
        birthday: (_a = item.user) === null || _a === void 0 ? void 0 : _a.birthday,
    });
};
exports.mapAccountListItemToSearchAccountItemType = mapAccountListItemToSearchAccountItemType;
//# sourceMappingURL=utils.js.map